// Shared by the termination form and server: the preview must match execution.
const plain = row => row && row.get ? row.get({plain: true}) : row;
function snapshot(row) {
    const p = plain(row);
    const updated = p.updated_at || p.updatedAt;
    return {id: Number(p.id), started_on: p.started_on || null, ended_on: p.ended_on || null,
        hiring_form: p.hiring_form || null, updated_at: updated ? new Date(updated).toISOString() : null};
}
function plan(periods, date) {
    const result = {closing: [], contracts: [], unchanged: [], future: []};
    periods.map(plain).forEach(p => {
        if (p.started_on > date) result.future.push(p);
        else if (p.ended_on && p.ended_on <= date) result.unchanged.push(p);
        else if (p.hiring_form === 'gph') result.contracts.push(p);
        else result.closing.push(p);
    });
    return result;
}
function token(periods) {
    return JSON.stringify(periods.map(snapshot).sort((a, b) => a.id - b.id));
}
function defaults(periods, date) {
    return periods.map(p => ({id: Number(p.id), mode: 'dismissal', end_date: date}));
}
function selectionError(periods, actions, date) {
    if (actions.length !== periods.length || new Set(actions.map(a => Number(a.id))).size !== periods.length) return 'Обновите список трудовых периодов и проверьте выбор.';
    for (const action of actions) {
        const period = periods.find(p => Number(p.id) === Number(action.id));
        if (!period || !['keep', 'dismissal', 'date'].includes(action.mode)) return 'Обновите список трудовых периодов и проверьте выбор.';
        if (action.mode === 'keep') continue;
        const end = action.mode === 'dismissal' ? date : action.end_date;
        if (!end) return 'Укажите дату прекращения каждого выбранного периода.';
        if (end < period.started_on) return 'Дата прекращения не может быть раньше начала самого трудового периода.';
    }
    return '';
}
module.exports = {plan, snapshot, token, defaults, selectionError};
